import { getRequest } from '../api-handler';
import { PackagingDetailDto } from './packaging';

export const PackagingApi = {
  getById: (id: number) => getRequest<PackagingDetailDto>(`/packagings/${id}`)
};
